
































































































































































































import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    Ref,
    ref,
    toRefs,
    watch,
} from '@vue/composition-api';
import ShowInfoItem from '@/components/show-info-item.vue';
import AuthConfirm from '@/components/auth-confirm/index.vue';
import {
    handleErrorMessageToast,
    handleSuccessMessageToast,
} from '@/common/util';
import InputText from '@/components/input/text.vue';
import { idReg, nameReg, PhoneReg } from '@/directives/isValid';
import QrCode from '@/components/qr/index.vue';
import { useApolloModel } from 'vue-apollo-model';
import { GlobalModel } from '@/views/model';
import { ProfileModel } from './model';
import { ManagerInfo } from '@/models/qualification';
import { skipLoadingWrapper } from '@/utils/helper';
import { cloneDeep } from 'lodash-es';
import { logout } from '@/common/logout';

export default defineComponent({
    components: {
        ShowInfoItem,
        AuthConfirm,
        InputText,
        QrCode,
    },
    setup(props, context) {
        const model = useApolloModel(ProfileModel);
        const globalModel = useApolloModel(GlobalModel);
    
        const state = reactive({
            isNeedAuth: false,
            isEditManager: false,
            isShowManager: true,
            phoneVerifyCode: '',
            isShowVerifyQrCode: false,
            idToken: '',
            isEditPhone: false,
            isEditEmail: false,
            timeLimit: 0,
            countDownTimer: 0,
            operation: '',
            operationToken: '',
        });
        const email = ref('');
        const managerInfo: Ref<ManagerInfo> = ref({
            managerName: '',
            managerIdNumber: '',
            managerPhone: '',
            managerUserId: '',
            managerFrontImgPath: '',
            managerBackImgPath: '',
        });
        const isSameUSer = computed(() => {
            return (
                globalModel.userInfo.userId === managerInfo.value.managerUserId
            );
        });
        const priorAuthWay = computed(() => {
            return isSameUSer.value ? 'qrcode' : 'email';
        });
        const realNameInfo = computed(() => {
            return {
                name: managerInfo.value.managerName.trim(),
                id: managerInfo.value.managerIdNumber.trim(),
            };
        });

        function confirmOperation(type: string) {
            if (type === 'change_manager') {
                state.operation = 'change_manager_limit';
            } else {
                state.operation = 'bind_mail_limit';
                state.isEditEmail = true;
            }
            state.isNeedAuth = true;
        }
        async function handleSuccessAuth(operateToken: string) {
            handleSuccessMessageToast('验证成功');
            state.isNeedAuth = false;
            if (state.isEditEmail) {
                context.root.$router.push({
                    path: `/platform/change/email?operation_token=${operateToken}`,
                });
            }
            if (state.isEditManager) {
                state.operationToken = operateToken;
                model.operationToken = operateToken;
                await model.profileUserInfoQuery.refetch();
                // eslint-disable-next-line no-use-before-define
                init();
                state.isShowManager = false;
                return;
            }
        }
        function cancelAuth() {
            if (state.isEditEmail) {
                state.isEditEmail = false;
            }
            state.isNeedAuth = false;
            state.isEditManager = false;
            state.isShowManager = true;
            state.phoneVerifyCode = '';
            state.isShowVerifyQrCode = false;
            state.idToken = '';
            state.isEditPhone = false;
            state.operationToken = '';
        }
        function editManager(type: string) {
            state.isEditManager = true;
            confirmOperation(type);
        }

        function clearIdToken() {
            state.idToken = '';
        }
        function updateVerifyQrCode() {
            state.isShowVerifyQrCode = !!(
                managerInfo.value.managerName &&
                nameReg.test(managerInfo.value.managerName) &&
                managerInfo.value.managerIdNumber &&
                idReg.test(managerInfo.value.managerIdNumber)
            );
        }
        function onQrCodeAccept(token: string) {
            state.idToken = token;
        }
        function handleRealInfoChange() {
            state.isShowVerifyQrCode = false;
            clearIdToken();
            updateVerifyQrCode();
            return;
        }
        async function refresh() {
            await model.profileUserInfoQuery.refetch();
            model.reset();
        }
        function init() {
            email.value = model.profileInfo.mail ?? '';
            managerInfo.value = cloneDeep(model.profileInfo.managerInfos[0]);
        }
        function cancelEditManager() {
            init();
            cancelAuth();
        }
        function exitLogin() {
            logout();
        }
        async function handleSubmit() {
            await model.updateManager({
                ...managerInfo.value,
                idToken: state.idToken,
                phoneVerifyCode: state.phoneVerifyCode,
                operation_token: state.operationToken,
            });
            if (model.updateManagerMutation.data.result !== 1) {
                handleErrorMessageToast(
                    model.updateManagerMutation.data.error_msg,
                );
                return;
            }
            handleSuccessMessageToast(
                `修改成功${isSameUSer.value ? '，请重新登录' : ''}`,
            );
            if (isSameUSer.value) {
                exitLogin();
                return;
            }
            refresh();
            init();
            cancelAuth();
        }
        const submit = skipLoadingWrapper(handleSubmit);
        function loopCheck() {
            state.timeLimit--;
            if (state.timeLimit) {
                // @ts-ignore
                state.countDownTimer = setTimeout(() => {
                    loopCheck();
                }, 1000);
            }
        }
        async function getPhoneCaptcha() {
            await model.getPhoneCaptcha(managerInfo.value.managerPhone);
            state.timeLimit = 60;
            loopCheck();
        }
        watch(
            () => managerInfo.value.managerName,
            (v) => {
                state.isShowVerifyQrCode = false;
                if (v !== model.profileInfo.managerInfos[0].managerName) {
                    managerInfo.value.managerIdNumber = '';
                }
            },
        );
        watch(
            () => managerInfo.value.managerIdNumber,
            async (v) => {
                state.isShowVerifyQrCode = false;
            },
        );
        watch(
            () => managerInfo.value.managerPhone,
            async (v) => {
               
                if (
                    v &&
                    PhoneReg.test(v) &&
                    v !== model.profileInfo.managerInfos[0].managerPhone
                ) {
                    state.isEditPhone = true;
                    return;
                }
                state.isEditPhone = false;
                state.timeLimit = 0;
                clearTimeout(state.countDownTimer);
            },
        );
        onMounted(() => {
            init();
        });
        return {
            model,
            globalModel,
            email,
            managerInfo,
            realNameInfo,
            priorAuthWay,
            confirmOperation,
            handleSuccessAuth,
            editManager,
            handleRealInfoChange,
            onQrCodeAccept,
            clearIdToken,
            cancelEditManager,
            submit,
            getPhoneCaptcha,
            cancelAuth,
            ...toRefs(state),
        };
    },
});
